import { render, staticRenderFns } from "./UserCenterEntry.vue?vue&type=template&id=0aa5d01a&"
import script from "./UserCenterEntry.vue?vue&type=script&lang=js&"
export * from "./UserCenterEntry.vue?vue&type=script&lang=js&"
import style0 from "./UserCenterEntry.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports